// AiDiagram (dgm-) — inline AI-drawn chat diagram: a glass placeholder/spinner while the
// backend renders the TikZ, then a responsive image, or a muted "unavailable" note on failure.
export const aiDiagramStyles = `
  .dgm-wrap { margin: 0.4rem 0; }
  .dgm-frame {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.4rem 0.75rem;
    border-radius: var(--rad-catchup-large, 12px);
    background-color: var(--catchup-blue-50, rgba(87, 194, 211, 0.1));
    color: var(--catchup-gray-500, #6b7280);
    font-size: var(--fs-md);
  }
  .dgm-text { color: var(--catchup-gray-500, #6b7280); font-size: var(--fs-md); }
  .dgm-img {
    max-width: 100%;
    height: auto;
    display: block;
    border-radius: var(--rad-catchup-large, 12px);
  }
`;
